// import { EventCallback, DelegatedEvent } from './Delegate.js';
// import { Delegate } from './Delegate.js';
import { Delegate, wcFoundationClasses } from '@bonusmap/shared_ui/library';
import type { EventCallback, DelegatedEvent } from '@bonusmap/shared_ui/library';
export class BaseWebComponent extends wcFoundationClasses.basic {
    shadowOptionImplementation?: 'open' | 'closed' | 'none'= 'none';
}
/**
 * implementazione base per i web component con gestione eventi delegata
 */
export abstract class BaseWebComponentNotUsed extends HTMLElement {
    static webComponentName: string = "base-web-component";
    static observedAttributes: string[] = [
        // List of attributes to observe for changes
    ];
    protected get webComponentName(): string {
        return (this.constructor as typeof BaseWebComponentNotUsed).webComponentName;
    }
    protected delegate: Delegate;
    constructor() {
        super();
        this.delegate = new Delegate(this);
    }
    // =============================
    // Event Delegation
    // =============================
    /**
       * Simile a jQuery.on
       */
    on<T extends Event = Event>(type: string, selector: string, handler: EventCallback<T>): void {
        this.delegate.on<T>(type, selector, handler);
    }

    /**
     * Simile a jQuery.off
     */
    off<T extends Event = Event>(type: string, selector: string, handler: EventCallback<T>): void {
        this.delegate.off<T>(type, selector, handler);
    }
    render(): void {
        // Override this method in derived classes to implement rendering logic
    }
    protected onConnected(): void {
        // Override this method in derived classes to implement logic when the component is added to the DOM
    }
    
    protected onDisconnected(): void {
        // Override this method in derived classes to implement logic when the component is removed from the DOM
    }
    protected onAttributeChange(name: string, oldValue: string, newValue: string): void {
        // Override this method in derived classes to handle attribute changes
    }
    protected onAdopted(): void {
        // Override this method in derived classes to handle when the component is moved to a new document
    }
    protected createRandomId(): string {
        return `component-${Math.random().toString(36).substring(2, 15)}`;
    }
    private connected = false;
    connectedCallback(): void {
        try {
            this.onConnected();
            this.render();
            this.connected = true;
        } catch (error) {
            console.error(`Error in connectedCallback for ${this.tagName}:`, error);
        }
    }

    disconnectedCallback(): void {
        this.delegate.destroy();
        this.onDisconnected();
    }

    adoptedCallback() {
        // console.log("Custom element moved to new page.");
        this.onAdopted();
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if(!this.connected) return;
        this.onAttributeChange(name, oldValue, newValue);
    }
    // =============================
    // Static Registration Method
    // =============================

    /**
     * Register the web component with customElements
     * Abstract classes should not be registered directly
     */
    static registerElement(): void {
        const elementClass = this;
        const name = elementClass.webComponentName;
        if (!customElements.get(name)) {
            customElements.define(name, elementClass as unknown as CustomElementConstructor);
        } else {
            console.warn(`Element ${name} is already defined.`);
        }
    }
}